export default function Hero() {
  return (
    <section className="border-b border-[#e3d7bd] bg-[#faf5eb]">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[1.6fr_1fr] lg:gap-14">
          {/* 主打标题区 —— 标题优先、配图克制 */}
          <div>
            <a
              href="#timeline"
              className="inline-flex items-center gap-2 border border-[#b1401f] px-2.5 py-1 text-[11px] tracking-widest text-[#b1401f]"
            >
              <i className="ri-archive-line text-xs" aria-hidden="true"></i>
              本期 · 呱呱黑料考古发现
            </a>
            <h2 className="font-display mt-6 text-3xl leading-[1.25] font-black text-[#1a160e] md:text-[2.9rem] md:leading-[1.22]">
              一段说了十年的狠话
              <br />
              终于拼出了它的完整脉络
            </h2>
            <p className="mt-6 max-w-[46rem] text-sm leading-7 text-[#6f6552] md:text-base md:leading-8">
              老料不在年份，而在没说完的那半句。这一卷把某位旧友十年前当众撂下的那句狠话，
              连同前后三年的台前态度、台下往来逐条对账——看看当初的早年言论，
              到底是怎么一步步长成今天众人回头翻捡的陈年往事。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#dossier"
                className="inline-flex items-center justify-center gap-2 bg-[#b1401f] px-5 py-3 text-sm font-medium text-[#faf5eb] whitespace-nowrap transition hover:bg-[#852f12]"
              >
                开卷读全篇
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </a>
              <button
                type="button"
                className="inline-flex cursor-pointer items-center justify-center gap-2 border border-[#1a160e] px-5 py-3 text-sm font-medium whitespace-nowrap transition hover:bg-[#1a160e] hover:text-[#faf5eb]"
              >
                <i className="ri-time-line text-base" aria-hidden="true"></i>
                只翻时间线
              </button>
            </div>

            <dl className="mt-10 grid max-w-[42rem] grid-cols-3 gap-4 border-t border-[#e3d7bd] pt-5 text-center">
              <div>
                <dt className="text-[11px] tracking-widest text-[#978a72]">追溯跨度</dt>
                <dd className="font-display mt-1 text-xl font-bold text-[#1a160e]">十年</dd>
              </div>
              <div>
                <dt className="text-[11px] tracking-widest text-[#978a72]">对账条目</dt>
                <dd className="font-display mt-1 text-xl font-bold text-[#b1401f]">37 则</dd>
              </div>
              <div>
                <dt className="text-[11px] tracking-widest text-[#978a72]">涉及旧卷</dt>
                <dd className="font-display mt-1 text-xl font-bold text-[#1a160e]">5 卷</dd>
              </div>
            </dl>
          </div>

          {/* 右侧：索引条 + 档案章，不做实景配图 */}
          <aside className="flex flex-col justify-between gap-8 border-l border-[#e3d7bd] pl-8 lg:pl-10">
            <div>
              <p className="text-[11px] tracking-[0.3em] text-[#b1401f]">READ · SLOWLY</p>
              <p className="mt-2 text-sm text-[#6f6552]">
                建议阅读时长约 <span className="font-display text-[#1a160e]">8 分钟</span>。
                按卷一页页翻，才不会被标题牵着走。
              </p>
            </div>

            <ol className="space-y-0 text-sm">
              {[
                "壹 · 狠话开出的那一天",
                "贰 · 台下三年的冷与热",
                "叁 · 旧友们的隐晦侧写",
                "肆 · 黑历史被重新提起时",
              ].map((t, i) => (
                <li key={t} className="flex items-center gap-3 border-t border-[#e3d7bd] py-3 text-[#1a160e]">
                  <span className="font-display w-6 text-[#978a72]">{String(i + 1).padStart(2, "0")}</span>
                  <span>{t}</span>
                </li>
              ))}
            </ol>

            <div className="flex items-center gap-4 border-t border-[#1a160e] pt-5">
              <i className="ri-error-warning-line text-2xl text-[#b1401f]" aria-hidden="true"></i>
              <p className="text-xs leading-5 text-[#6f6552]">
                本站所有旧账均为虚构整理展示，仅作阅读与形式编排，不指向任何真实人物与事件。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}